import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {Constant} from 'config/constant';
import {RootState} from 'redux/store';
import {getErrorMessage,} from 'api';
import { logout } from './authSlice';
import {
    RegisterChargerProtocolData
} from 'types';
import {createChargerProtocol, getListChargerProtocol, UpdateChargerProtocol, deleteChargerProtocol } from 'api/chargerProtocol';

export type chargerProtocolData = {
    uuid: string,
    name: string,
    en_name: string,
}
export type ListChargerProtocol = {
    error: boolean;
    loading: boolean;
    success: boolean;
    chargerProtocol: chargerProtocolData[];
    status: string;
};

export type ChargerProtocolState = {
    status: number;
    chargerProtocolData: chargerProtocolData[];
    listChargerProtocol: ListChargerProtocol;
    detailsChargerProtocol: chargerProtocolData;
    register: {
        loading: boolean;
        success: boolean;
        error: boolean;
        message: string;
    };
    update: {
        success: boolean;
        error: boolean;
        messages: string;
        loading: boolean;
    };
    delete: {
        success: boolean;
        error: boolean;
        messages: string;
        loading: boolean;
    };
    detail: {
        success: boolean;
        error: boolean;
        messages: string;
        loading: boolean;
        dataDetail: chargerProtocolData;
    };
}

export const createChargerProtocolA = createAsyncThunk(
    'admin/charger-protocol/store',
    async (params: RegisterChargerProtocolData, { dispatch, rejectWithValue }) => {
        try {
            let response = await createChargerProtocol(params);
            const { data = {}, success } = response.data;
            if (success) {
                dispatch(setNewChargerProtocol(data));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setNewChargerProtocol(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const updateChargerProtocol = createAsyncThunk(
    '/admin/charger-protocol/update',
    async (params: { uuid: string, name: string }, { dispatch, rejectWithValue }) => {
        try {
            let response = await UpdateChargerProtocol(params);
            const { success } = response.data;
            if (success) {
            dispatch(setUpdateChargerProtocol({params}));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setUpdateChargerProtocol(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const destoryChargerProtocol = createAsyncThunk(
    '/admin/charger-protocol/delete',
    async (params: { uuid: string, lang:string }, { dispatch, rejectWithValue }) => {
        try {
            let response = await deleteChargerProtocol(params);
            const { success } = response.data;
            if (success) {
                dispatch(setDeleteChargerProtocol({params}));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setDeleteChargerProtocol(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const chargerProtocolSlice = createSlice(
    {
        name: 'chargerProtocol',
        initialState: {
            status: Constant.DEFAULT_STATUS,
            chargerProtocolData: [],
            register: {
                loading: false,
                success: false,
                error: false,
                message: '',
            },
            update: {
                success: false,
                error: false,
                messages: '',
                loading: false,
            },
            delete: {
                success: false,
                error: false,
                messages: '',
                loading: false,
            },
            listChargerProtocol: {
                error: false,
                loading: false,
                success: false,
                notification: [],
                pagination: {
                    total: 0,
                    perPage: Constant.PAGE_SIZE_NEW,
                    currentPage: Constant.DEFAULT_PAGE,
                    lastPage: Constant.DEFAULT_PAGE,
                },
                status: '',
            },
            listSearchPlace: {
                error: false,
                loading: false,
                success: false,
                places: [],
            }
        } as unknown as ChargerProtocolState,
        reducers:{
            resetRegisterState: (state: ChargerProtocolState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.register = {
                    success: false,
                    loading: false,
                    message: '',
                    error: false,
                };
            },
            setNewChargerProtocol: (state, action) => {
                state.chargerProtocolData = action?.payload ?? [];
                state.status = action?.payload?.response?.status;
                state.register.message = action?.payload?.response?.data?.message;
            },
            setListChargerProtocol: (state: ChargerProtocolState, { payload }) => {
                const { chargerProtocol } = payload;
                state.listChargerProtocol.chargerProtocol = chargerProtocol;
            },
            setDetailsChargerProtocol:(state: ChargerProtocolState, {payload}) => {
                state.detailsChargerProtocol = {
                    name: payload.detailsChargerProtocol.name,
                    en_name: payload.detailsChargerProtocol.en_name,
                    uuid: payload.detailsChargerProtocol.uuid
                }
            },
            setDeleteChargerProtocol: (state: ChargerProtocolState, { payload }) => {
                state.status = payload?.response?.status;
            },
            setUpdateChargerProtocol: (state, action) => {
                state.chargerProtocolData = action?.payload?.params ?? [];
                state.status = action?.payload?.response?.status;
                state.update.messages = action?.payload?.response?.data?.message;
            },
            resetUpdateState: (state: ChargerProtocolState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.update = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            },
            resetDeleteState: (state: ChargerProtocolState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.delete = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            },
            resetListChargerProtocolState: (state: ChargerProtocolState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.update = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            }
        },
        extraReducers: (builder) => {
            builder
                .addCase(createChargerProtocolA.pending, (state: ChargerProtocolState) => {
                    state.register.loading = true;
                })
                .addCase(createChargerProtocolA.rejected, (state: ChargerProtocolState, { payload }) => {
                    state.register.loading = false;
                    state.register.success = false;
                    state.register.error = true;
                    state.register.message = payload as string;
                })
                .addCase(createChargerProtocolA.fulfilled, (state: ChargerProtocolState) => {
                    state.register.loading = false;
                    state.register.success = true;
                    state.register.error = false;
                })
                .addCase(updateChargerProtocol.pending, (state: ChargerProtocolState) => {
                    state.update.loading = true;
                })
                .addCase(updateChargerProtocol.rejected, (state: ChargerProtocolState) => {
                    state.update.loading = false;
                    state.update.success = false;
                    state.update.error = true;
                })
                .addCase(updateChargerProtocol.fulfilled, (state: ChargerProtocolState) => {
                    state.update.loading = false;
                    state.update.success = true;
                    state.update.error = false;
                })
                .addCase(fetchListChargerProtocol.pending, (state: ChargerProtocolState) => {
                    state.listChargerProtocol.loading = true;
                })
                .addCase(fetchListChargerProtocol.rejected, (state: ChargerProtocolState) => {
                    state.listChargerProtocol.loading = false;
                    state.listChargerProtocol.success = false;
                    state.listChargerProtocol.error = true;
                })
                .addCase(fetchListChargerProtocol.fulfilled, (state: ChargerProtocolState) => {
                    state.listChargerProtocol.loading = false;
                    state.listChargerProtocol.success = true;
                    state.listChargerProtocol.error = false;
                })
                .addCase(destoryChargerProtocol.pending, (state: ChargerProtocolState) => {
                    state.delete.loading = true;
                    state.delete.success = false;
                    state.delete.error = false;
                })
                .addCase(destoryChargerProtocol.rejected, (state: ChargerProtocolState, {payload}) => {
                    state.delete.loading = false;
                    state.delete.success = false;
                    state.delete.error = true;
                    state.delete.messages = payload as string;
                })
                .addCase(destoryChargerProtocol.fulfilled, (state: ChargerProtocolState) => {
                    state.delete.loading = false;
                    state.delete.success = true;
                    state.delete.error = false;
                })
        },
    }
);

export const fetchListChargerProtocol = createAsyncThunk(
    'admin/charger-protocol',
    async (params: {}, { dispatch, rejectWithValue }) => {
        try {
            const response = await getListChargerProtocol(params);
            const {
                data = [],
                success,
            } = response.data;
            if (success) {
                let m = 0;
                if(data.length>0) {
                    for (const elem of data) {
                        m+=1;
                        elem['no'] = m;
                    }
                }
                dispatch(setListChargerProtocol({ chargerProtocol: data }));
                return true;
            }
        } catch (error: any) {
            dispatch(setListChargerProtocol(error));
            return rejectWithValue(getErrorMessage(error));
        }
        return rejectWithValue(false);
    }
);

export const {
    setListChargerProtocol,
    resetRegisterState,
    setNewChargerProtocol,
    setDeleteChargerProtocol,
    resetUpdateState,
    setUpdateChargerProtocol,
    resetDeleteState,
    resetListChargerProtocolState,
    setDetailsChargerProtocol
} = chargerProtocolSlice.actions
export const chargerProtocolSelector = (state: RootState) => state.chargerProtocol;